<template>
    <div class="loading loading--countdown d-flex flex-column justify-content-center">
        <div class="loading__inner">
            <span class="loading__counter">
                {{ this.countDown }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        seconds: {
            type: Number,
            required: false,
            default: 5
        }
    },
    data() {
        return {
            countDown: this.seconds,
        };
    },
    mounted() {
        this.countDownTimer();
    },
    methods: {
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.countDownTimer();

                    if(this.countDown == 0) {
                        this.$emit('completed');
                    }
                }, 1000);
            }
        },
    }
};
</script>